import Menu from "./Menu";

export default class Page {
	constructor () {
		console.log('Page');

		new Menu();

	}
}